import {AppIdSchema} from '@cohort/shared/schema/apps';
import {asArray, DateSchema} from '@cohort/shared/schema/common';
import {parseValue, UserAttributeValueSchema} from '@cohort/shared/schema/common/userAttribute';
import {UserPropertyDataTypeSchema} from '@cohort/shared/schema/common/userProperty';
import {z} from 'zod';

export const UserAttributeASchema = z
  .object({
    id: z.string().uuid(),
    userId: z.string().uuid(),
    userPropertyId: z.string().uuid(),
    dataType: UserPropertyDataTypeSchema,
    referenceId: z.string(),
    appId: AppIdSchema.nullable(),
    value: UserAttributeValueSchema,
    createdAt: DateSchema,
    updatedAt: DateSchema,
  })
  .transform(data => {
    const value = parseValue(data.dataType, data.value);
    return {
      ...data,
      value,
    };
  });
export type UserAttributeADto = z.infer<typeof UserAttributeASchema>;

// List user attributes
export const ListUserAttributesParamsASchema = z.object({
  userId: z.string().uuid(),
  userPropertyIds: z.preprocess(asArray, z.array(z.string().uuid())),
});
export type ListUserAttributesParamsADto = z.infer<typeof ListUserAttributesParamsASchema>;

// Update user attributes
export const UpdateAttributesDataASchema = z
  .array(
    z.object({
      userId: z.string().uuid(),
      userPropertyId: z.string().uuid(),
      value: UserAttributeValueSchema.nullable(),
    })
  )
  .min(1)
  .max(1000);
export type UpdateUserAttributesDataADto = z.infer<typeof UpdateAttributesDataASchema>;
